<template>
  <v-app>
    <v-main>
      <div class="home">
        <div v-if="isLogin"><Principal /></div>
        <div v-else><Login /></div>

        <Principalv2 v-if="false" />
      </div>
      <confirm ref="confirm"></confirm>
      <confirm-text ref="confirm_text" />
      <notify ref="notify"></notify>

      <AModalConvenio ref="amodalconvenio" />
    </v-main>
  </v-app>
</template>

<style>
  .bit {
    background-size: calc(((100vw - 400px) / 2) - 32px), calc(((100vw - 400px) / 2) - 32px), cover;
    background-attachment: fixed, fixed;
    background-size: 368px, 368px;
    background-repeat: no-repeat, no-repeat;
    background-position: left bottom, right bottom;
  }
</style>

<script>
  import Login from '@/Login.vue';
  import Principal from '@/views/Principal.vue';
  import Principalv2 from '@/views/Principalv2.vue';
  import Confirm from '@/components/vuetify/ConfirmDialog.vue';
  import ConfirmText from '@/components/vuetify/ConfirmDialogText.vue';
  import Notify from '@/components/vuetify/Notify.vue';
  import AModalConvenio from '@/components/AModalConvenioSelect.vue';
  export default {
    name: 'home',
    data() {
      return {
        isLogin: this.$store.state.isLogin,
      };
    },
    components: { Login, Principal, Principalv2, Confirm, Notify, ConfirmText, AModalConvenio },
    watch: {
      /* '$store.state.convenio': function(){
        this.abrirelmodalcito();
      }, */
      '$store.state.CARGO'() {
        /*window.console.log(
          '$store.state.convenio',
          this.$store.state.convenio,
          this.$store.state.CARGO,
          this.$store.state.CARGO.sede.unidad_negocio,
        );*/
        
        this.abrirelmodalcito();
      },
    },
    methods: {
      blockconsole() {
        let host = window.location.href;
        if (host.includes('localhost:')) {
          window.console.log('CONSOLA DISPONIBLE EN LOCALHOST.');
          return;
        }
        (function() {
          window.console.log = function() {};
          window.console.error = function() {};
          window.console.info = function() {};
        })();
      },
      abrirelmodalcito() {
        const cargo = this.$store.state.CARGO;
        if (cargo && (cargo.sede.unidad_negocio == 1 || cargo.sede.unidad_negocio == 10)) {
          if (!this.$store.state.convenio) {
            this.$refs.amodalconvenio.getConveniosUniversidades();
            this.$refs.amodalconvenio.openmodal();
          }
        }
      },
    },
    mounted() {
      this.$root.$confirm = this.$refs.confirm;
      this.$root.$confirm_text = this.$refs.confirm_text;
      this.$root.$notify = this.$refs.notify;
      this.blockconsole();
    },
  };
</script>
